// extracted by mini-css-extract-plugin
export default {"product":"ProductDetail_product__oe5+R","detail":"ProductDetail_detail__oXSP1","rating":"ProductDetail_rating__6r7CS"};